export default __webpack_public_path__ + "static/media/greenspacedestlocked_trans.01f95aa2.png";